import { render, staticRenderFns } from "./Recebimentos.vue?vue&type=template&id=a1035f80&"
import script from "./Recebimentos.vue?vue&type=script&lang=js&"
export * from "./Recebimentos.vue?vue&type=script&lang=js&"
import style0 from "./Recebimentos.vue?vue&type=style&index=0&id=a1035f80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports